import { SettingsRepository } from "approot/admin/serversettings/settings.repository";
import { NsModalButton } from "approot/global/ui-components/nsModal";

import "webroot/static/vendor/components/jquery.cookie.js";
import "regenerator-runtime/runtime";

export class LoginNoticeService {
	/*@ngInject*/
	constructor(
		private $uibModal: ng.ui.bootstrap.IModalService,
		private settingsRepository: SettingsRepository
	) {
	}

	async noticeProcess() {
		const settings = await this.settingsRepository.getPopupWindowOnLoginScreenSettings();

		if (!settings.showPopUp) {
			return;
		}

		let hash = parseInt(this.readHash());
		let getHash = this.hashCode(settings.popUpDisplayText);

		if (hash == getHash) {
			return;
		}

		let msg = `<div class='text-left' style='font-size: 16;'>${settings.popUpDisplayText}</div>`;
		// опции диалога уведомления
		let opts = {
			msg: msg,
			btnTitle: settings.popUpButtonText,
			success: () => {
				if (settings.popUpDisplayText) {
					this.setHash(getHash);
				}
			}
		};

		this.showNotice(opts);
	}

	private showNotice(opts) {
		const modalInstance = this.$uibModal.open({
			backdrop: "static",
			controller: class {
				public header: string;
				public buttons: NsModalButton[];
				public msg: string;

				/*@ngInject*/
				constructor(
					private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
					public language: any
				) {
					this.header = language.Generic.Common.kAttention;
					this.buttons = [{
						title: opts.btnTitle,
						action: () => {
							this.$uibModalInstance.close();
						}
					}];
					this.msg = opts.msg;
				}

				close() {
					this.$uibModalInstance.dismiss();
				}
			},
			controllerAs: "$ctrl",
			template: `
				<ns-modal controller="$ctrl" header="{{$ctrl.header}}" buttons="$ctrl.buttons">
					<div class="wrap-pre" ng-bind-html="$ctrl.msg"></div>
				</ns-modal>`
		});

		modalInstance.result.then(() => {
			opts.success();
		});
	}

	private hashCode(src: string) {
		let hash = 0;
		for (let i = 0; i < src.length; i++) {
			hash = ~~(((hash << 5) - hash) + src.charCodeAt(i));
		}
		return hash;
	}

	private readHash(): string {
		return (<any>$).cookie("hash-notice_state");
	}

	private setHash(hashCode): void {
		let expires = 365 * 24 * 60 * 60;
		// установка куки
		let date = new Date();

		date.setTime(date.getTime() + expires * 1000);
		(<any>$).cookie("hash-notice_state", hashCode, { expires: date });
	}
}